var version = {
    "name":      "dativery",
    "buildDateCode": "20260203-094659",
    "buildDate": "Tue Feb 03 2026 09:46:59 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260203-094659",
    "backupUIVersion": "2.2.0-20250519-102244"
}
;
 export default version;